import React from "react";
import { Link } from "gatsby";
import "./button.scss";
import { useRipple } from "../../hooks";

const Button = ({
  children,
  linkTo,
  externalLink,
  onClick,
  target,
  btnStyle,
  btnSize,
  addClass,
  ripple,
  ref,
}) => {
  const [addRipple, ripples] = useRipple();
  const styles = `
  button
  ${btnStyle ? btnStyle : "primary"}
  ${btnSize ? btnSize : "md"}
  ${addClass && addClass}
  `;

  const BaseButton = () => {
    return (
      <button className={styles} onClick={addRipple} ref={ref}>
        <span className="button__label">{children}</span>
        {ripple && <span className="button__ripple-container">{ripples}</span>}
        {/* {ripples} */}
      </button>
    );
  };

  if (linkTo) {
    return (
      <Link to={linkTo}>
        <BaseButton />
      </Link>
    );
  }

  if (externalLink) {
    return (
      <a
        href={externalLink}
        className="button__link"
        rel="noopener noreferrer"
        target={target}
      >
        <BaseButton />
      </a>
    );
  }

  return <BaseButton />;
};

export default Button;
